export function getListRowCount(payload) {
  if (Array.isArray(payload)) {
    return payload.length;
  }

  if (payload && typeof payload === "object") {
    const candidateKeys = ["data", "rows", "records", "items", "content", "result", "results", "list"];
    for (const key of candidateKeys) {
      if (Array.isArray(payload[key])) {
        return payload[key].length;
      }
    }
  }

  return 0;
}
